export enum RecurringInterval {
  HOUR,
  DAY,
  WEEK,
  MONTH,
  YEAR,
}
